import type { EditableStoryboard } from "./api";

/**
 * Turn a storyboard into a plain-text brief to hand to Maestro. Maestro has no
 * knowledge of the article's storyboard, so someone building the reel by hand
 * there needs the whole תסריט in one place — per scene: the Hebrew narration to
 * voice, the visual to generate, the burned-in caption, and the timing.
 */
export function buildMaestroBrief(sb: EditableStoryboard): string {
  const out: string[] = [];
  out.push(`Maestro brief — ${sb.h1}`);
  out.push(`Format: ${sb.aspectRatio} · ~${sb.totalSec}s · ${sb.scenes.length} scenes`);
  if (sb.musicCue) out.push(`Music mood: ${sb.musicCue}`);
  out.push(`Hook: ${sb.hook}`);
  if (sb.cta) out.push(`CTA: ${sb.cta}`);
  out.push("");
  sb.scenes.forEach((s, i) => {
    out.push(`── Scene ${i + 1} · ${s.durationSec}s · motion:${s.imageMotion} · transition:${s.transition}`);
    out.push(`Narration (he): ${s.narration}`);
    out.push(`Caption (he):   ${s.hebrewCaption}`);
    out.push(`Visual (en):    ${s.imagePrompt}`);
    if (s.visualNote) out.push(`Note:           ${s.visualNote}`);
    out.push("");
  });
  out.push(`Brand: ${sb.brandWatermark ?? "AlternaBe"}`);
  return out.join("\n");
}

/** Copy text to the clipboard; returns false if the browser blocks it. */
export async function copyToClipboard(text: string): Promise<boolean> {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch {
    return false;
  }
}

/** Save text as a downloadable file. */
export function downloadText(filename: string, text: string): void {
  const url = URL.createObjectURL(new Blob([text], { type: "text/plain;charset=utf-8" }));
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}
